import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { UtilityModule } from "@coso/utility";
import { AlertModule } from "ngx-bootstrap/alert";
import { PageHeaderComponent } from "./page-header.component";

@NgModule({
  declarations: [PageHeaderComponent],
  imports: [CommonModule, CosoAlertModule, AlertModule, RouterModule, UtilityModule, AlertMessageComponent],
  exports: [PageHeaderComponent]
})
export class PageHeaderModule {}
